import { Statistic, Table} from 'antd'

import React, {useState, useEffect} from 'react'



function ClaimTableDiscord() {
    const [result, setResult] = useState([])
    const [loading, setLoading] = useState(false)

    const columns = [
      {
        title: 'Date claim',
        dataIndex: 'sentAt',
        key: 'sentAt',
        render: (d) => {
          d = d['$date']
          return new Date(d).toLocaleDateString() + " " + new Date(d).toLocaleTimeString()
        }
      },
      {
        title: 'XDG Claimed',
        dataIndex: 'amount',
        key: 'amount',
      },
      {
        title: 'DogeNano Hash',
        dataIndex: 'hashSent',
        key: 'hashSent',
        render: (r) => <a href={'https://explorer.dogenano.io/block/'+r}>View</a>
      },
      {
        title: 'Message claim',
        dataIndex: 'messageClaim',
        key: 'messageClaim',
        render: (r, row) => <a href={'https://discord.com/channels/'+ row.messageGuildId + "/" + row.messageChannelId + "/" + row.messageId}>View</a>
      },
      {
        title: 'Discord username',
        dataIndex: 'discordUsername',
        key: 'discordUsername',
      },
      {
        title: 'Discord Id',
        dataIndex: 'discordId',
        key: 'discordId',
      },
      
      {
        title: 'Message DCounter verification',
        dataIndex: 'user',
        key: 'user',
        render: (user, row) => <a href={'https://discord.com/channels/'+ user[0].messageVerifiedGuildId + "/" + user[0].messageVerifiedChannelId + "/" + user[0].messageVerifiedId}>View</a>
      },
      {
        title: 'DogeNano Address',
        dataIndex: 'dogeNanoAddress',
        key: 'dogeNanoAddress',
      },
    ];
    
    useEffect(() => {
      setLoading(true)
      import('./distribution-data/discord.claims.json').then((r) => {
        const data = r.default
        // sort by date
        data.sort((a,b) => new Date(b.sentAt['$date']) - new Date(a.sentAt['$date']))
        setResult(data)
        setLoading(false)
      })
        
    }, [])
    
  return (
    <div>
      <b>Total:</b> {result.reduce((a, b) => a + b.amount, 0).toLocaleString('en-US')} XDG<br/>
      <Table 
      size='small'
      pagination={{defaultPageSize: 5}}
      loading={loading} scroll={{x: true}} dataSource={result} columns={columns} />
    </div>
  )
}

export default ClaimTableDiscord